import * as React from 'react'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import dayjs from 'dayjs'

export const MuiDatePicker = ({
  minDate = null,
  maxDate = null,
  format = 'DD/MM/YYYY',
  onChange,
  label = '',
  value = null,
  error = ''
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
        <DatePicker
          onChange={onChange}
          value={value}
          format={format}
          minDate={dayjs(minDate)}
          maxDate={dayjs(maxDate)}
        />
      </DemoContainer>
      {error && (
        <div  className='error-message'>
          {error}
        </div>
      )}
    </LocalizationProvider>
  )
}
